import { ResponseService } from './response.service';
import { ApiService } from './api.service';
import { Injectable, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Injectable()
export class RodoClientService {
    private answer: Boolean;
    private categories = [];
    private options = {};

    constructor(
        public apiService: ApiService,
        public notificationService: NotificationsService,
        public translate: TranslateService
    ) { }

    clear() {
        this.answer = false;
        this.categories = [];
        this.options = {};
    }

    getCategories() {
        return this.categories;
    }

    addCategory(name) {
        let exists = this.categories.find(value => {
            if (value.name === name) {
                return true;
            }
        });
        if (!exists) {
            this.categories.push({ name: name, positions: [] });
        }
    }

    deleteCategory(categoryIndex) {
        this.categories.splice(categoryIndex,1);
    }

    addPosition(categoryName, positionValue){
        this.categories.forEach((value, index) => {
            if(value.name == categoryName){
                this.categories[index].positions.push(positionValue);
                return;
            }
        });

    }

    deletePosition(categoryIndex, positionIndex) {
        this.categories[categoryIndex].positions.splice(positionIndex,1);
    }

    verifyData(answer){
        this.options = {};
        let positionsExists = false;
        if(!answer){
            return true;
        }
        this.categories.forEach((value,index) => {
            if(value.positions.length){
                this.options[value.name] = value.positions;
                positionsExists = true;
            }
        });
        if(answer && positionsExists){
            return true
        }
        return false;
    }

    saveClientRodo(answer, contractId, modal) {
        if(!this.verifyData(answer)){
            this.notificationService.error('ERROR!', this.translate.instant('RODO.CONTRACT.NO_POSITIONS'));
            return false;
        }
        return this.apiService.post('/rodo/contract/'+contractId, answer === true ? {options: this.options} : {}).subscribe(response => {
            if(response.status.message === 'rodo.contract.created'){
                this.clear();
                this.notificationService.success('OK!', this.translate.instant('RODO.CONTRACT.CREATED'));
                modal.close();
                return;
            }
            this.notificationService.error('ERROR!', this.translate.instant(response.status.message.toUpperCase()));
        }, error => {
            this.notificationService.error('ERROR!', this.translate.instant(error.status.message.toUpperCase()));
            return false;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/services/rodo-client.service.ts